export default "<ion-nav #orderFlowNav></ion-nav>\n";